// Native
import {useState} from "react"
import {Badge, Box, Button, Flex, Grid, GridItem, Stack, Table, Text, useDisclosure} from "@chakra-ui/react"
import moment from "moment"

// Custom
import {Parts, UI} from "components"
import {Styles} from "config"
import useBankAccounts from "hooks/useBankAccounts"
import useWithdrawals from "hooks/useWithrawals"
import useOptions from "hooks/useOptions";

export default function Financial() {

    const [page, setPage] = useState(1)
    const withdrawals = useWithdrawals(page)
    const bank_accounts = useBankAccounts()
    const withdraw = withdrawals.data?.data?.filter(item => [2, 3].includes(item.status))?.[0]
    const [withdrawInfo, setWithdrawInfo] = useState(false)
    const [bankInfo, setBankInfo] = useState()
    const newAccountDialog = useDisclosure()
    const minWithdrawAmount = ((120)).toFixed(2) || "--";

    const columns = [
        {children: 'Código'},
        {children: 'Status'},
        {children: 'Valor'},
        {children: 'Data', textAlign: "right"}
    ];

    return (
        <>
            <UI.Header title="Contas & Saques"/>

            <UI.Alert status="warning" my={4} size="sm">
                <Stack direction="row" justify="space-between" align="center" spacing={4}>
                    <Box>Para solicitar saque, é necessário: Estar Ativo. Ter realizado compras de no mínimo:
                            R${minWithdrawAmount}.
                    </Box>

                    <Box> Caso ainda tenha dúvidas, entre em contato com nosso suporte:{" "}
                        <Button
                            colorPalette="green"
                            variant="outline"
                            size="sm"
                            onClick={() => window.open('https://api.whatsapp.com/send?phone=556299555388&text=Preciso%20de%20ajuda', '_blank')}
                        >
                            <UI.Icon name="whatsapp"/>
                            <Text fontSize="xs" fontWeight="bold">Suporte</Text>
                        </Button>
                    </Box>
                </Stack>
            </UI.Alert>

            <Grid templateColumns={{base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: '2fr 3fr'}} gap={4} mb={4}>

                <GridItem>
                    {withdraw ? <Parts.Widgets.Withdraws.Current/> : <Parts.Widgets.Withdraws.Request/>}
                </GridItem>

                <GridItem>
                    <Flex justifyContent="space-between">
                        <Text children="Contas e chaves pix:" color="GrayText"/>
                        <Button size="xs" colorPalette="orange" onClick={newAccountDialog.onOpen}>
                            <UI.Icon name="bank"/>Adicionar conta
                        </Button>
                    </Flex>

                    <Grid templateColumns={{base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(2, 1fr)'}} gap={4}
                          mt={4}>
                        {
                            bank_accounts.data?.map(item => <GridItem key={item.id}>
                                <UI.Pressable onClick={() => setBankInfo(item)}>
                                    <UI.Bank data={item}/>
                                </UI.Pressable>
                            </GridItem>)
                        }
                    </Grid>

                </GridItem>

            </Grid>

            <UI.Table
                loading={withdrawals.isFetching}
                loadingText="Carregando pedidos de saque..."
                label="Histórico de pedidos de saque"
                columns={columns}
                data={withdrawals.data?.data}
                meta={withdrawals.data?.meta}
                Row={Row}
                onPageChange={e => setPage(e.page)}
                onRowClick={item => setWithdrawInfo(item)}
            />

            <Parts.Dialog.Withdraws.View
                open={!!withdrawInfo}
                data={withdrawInfo}
                onClose={() => setWithdrawInfo(false)}
            />
            <Parts.Dialog.Bank.View
                open={!!bankInfo}
                data={bankInfo}
                onClose={() => setBankInfo(false)}
            />
            <Parts.Dialog.Bank.Register {...newAccountDialog} />
        </>
    )
}

const Row = (
    {
        data, onClick = () => {
    }, ...props
    }) => {
    const status = Styles.withdrawStatus(data?.status)

    return (
        <Table.Row cursor="pointer" key={data.id} onClick={() => onClick(data)} {...props}>
            <Table.Cell color="GrayText">{data.cod}</Table.Cell>
            <Table.Cell>
                <Badge colorPalette={status.colorPalette}>
                    <UI.Icon name={status.icon}/>
                    {data.status_label}
                </Badge>
            </Table.Cell>
            <Table.Cell>
                <UI.Number.Amount value={data.total}/>
            </Table.Cell>
            <Table.Cell textAlign="right" color="GrayText">{moment(data.created_at).format('LLL')}</Table.Cell>
        </Table.Row>
    )
}